import { createApp } from 'vue'
import App from './App.vue'
import './assets/solvea-theme.css'
import router from './router'
import { setUnauthorizedHandler } from './services/api'
import { clearMe } from './services/auth'

// Lives here, not in api.js — this is exactly the router->View->api.js
// ->router cycle that was fixed once already; api.js only calls out to a
// handler main.js injects, it never imports the router itself.
//
// 401 = no/invalid session. One login page now handles both internal and
// Reader-Portal accounts (see LoginView.vue), so there's no more area-based
// choice of which login page to send someone back to. 403 is intentionally
// NOT handled here — that's "authenticated but forbidden", which the
// calling view shows as an inline message, not a logout/redirect (see
// Teil 5).
setUnauthorizedHandler(() => {
  clearMe()
  if (router.currentRoute.value.name !== 'Login') {
    router.push({ name: 'Login', query: { redirect: router.currentRoute.value.fullPath } })
  }
})

createApp(App).use(router).mount('#app')
